import './App.css';
import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
// import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
// import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";



const useStyles = makeStyles((theme) => ({
    root: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  }));
  
  function ScrollTop(props) {
    const { children, window } = props;
    const classes = useStyles();
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    });
  
    const handleClick = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
  
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
  
    return (
      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root}>
          {children}
        </div>
      </Zoom>
    );
  }
  
  ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };
  
  export default function Header(props) {
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar>
          <Toolbar style={{backgroundColor:"#CC6600", overflow:"hidden"}}>
            <Typography style={{'flex': 1, 'visibility': 'hidden'}} variant="h4">大舜之光</Typography>
            <div className="header-right">
              <Link to='/' className="header-active" href="/">首页</Link>
              {/* <Link to="/Masterpiece">作品</Link>
              <Link to="/Author">作者</Link> */}
            </div>
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        {/* <ScrollTop {...props}>
          <Button  color="grey" variant="contained" size="large" aria-label="scroll back to top" style={{'borderRadius': 0, 'boxShadow': 'none', 'backgroundColor': '#e3bd8d'}}>
            <KeyboardArrowUpIcon />
          </Button>
        </ScrollTop>     */}
        </React.Fragment>
  );
}